'use client'

import Read from "./Read";
import {useEvoContext} from "../../context/evo.context";

export default function ReadPublic() {

    const {isLoggedIn} = useEvoContext();

    return (
        <Read publicIssue={isLoggedIn} />
    );
}